import * as React from "react";
const SvgArrowLeftS = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m10.828 12 4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" }));
export default SvgArrowLeftS;
